var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',_vm._g(_vm._b({class:( _obj = {
    's-button': true,
    's-button--loading': _vm.loading
  }, _obj[("s-button--" + _vm.size)] = true, _obj['s-button--no-margin'] =  !_vm.showMargin, _obj ),attrs:{"color":_vm.colour,"disabled":_vm.disabled,"outlined":_vm.outline,"block":_vm.block,"text":_vm.flat,"to":_vm.to,"elevation":0}},"v-btn",_vm._d({},[_vm.size,true])),_vm.$listeners),[(!_vm.loading)?_vm._t("default"):_vm._e(),(_vm.loading)?_c('s-circular-loader',{attrs:{"size":24,"color":"color"}}):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }